import React, { Component } from 'react';
import { Link } from "react-router-dom";
import publicApi from "../../utils/publicApi";
import { isPublicArticle } from "../../utils/articleVisibility";
import Loading from './Loading';
import SafeImage from '../shared/SafeImage';

import w1 from './../../img/work/w1.jpg';
import w2 from './../../img/work/w2.jpg';
import w3 from './../../img/work/w3.jpg';
import w4 from './../../img/work/w4.jpg';
import w5 from './../../img/work/w5.jpg';
import w6 from './../../img/work/w6.jpg';
import isEmpty from "is-empty";

let image_rand = [w1, w2, w3, w4, w5, w6];

// Fonction pour mapper le type d'article à la catégorie CSS
const getCategoryFromType = (type) => {
    switch (type) {
        case 'STAGE':
            return 'stage';
        case 'PPE':
            return 'ppe';
        case 'PP':
            return 'pp';
        case 'VEILLE_TECHNOLOGIQUE':
        case 'VEILLE_JURIDIQUE':
            return 'veille';
        default:
            return 'all';
    }
};

export default class Work extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: this.props.title ? this.props.title : '',
            description: this.props.description ? this.props.description : '',
            list: [],
            loading: true,
            error: null,
            wow_duration: 1,
        };

    }

    componentDidMount() {
        this.loadArticles();
        // Empêcher Isotope de s'initialiser sur cette section
        this.disableIsotope();
    }

    componentDidUpdate(prevProps, prevState) {
        // Réinitialiser le filtrage après le chargement des articles
        if (!this.state.loading && this.state.list.length > 0 &&
            (prevState.loading !== this.state.loading || prevState.list.length !== this.state.list.length)) {
            this.initFiltering();
        }
    }

    disableIsotope = () => {
        // Détruire Isotope s'il a été initialisé par main.js
        setTimeout(() => {
            if (window.$ && window.$.fn.isotope) {
                // Chercher toutes les grilles dans #work et les détruire
                window.$("#work .grid, #work .row").each(function () {
                    const $el = window.$(this);
                    if ($el.data('isotope')) {
                        $el.isotope('destroy');
                    }
                });
            }
        }, 100);
    }

    initFiltering = () => {
        // Initialiser le filtrage simple sans Isotope
        setTimeout(() => {
            if (window.$) {
                const self = this;
                window.$('#work .filters ul li').off('click.workFilter').on('click.workFilter', function () {
                    window.$('#work .filters ul li').removeClass('active');
                    window.$(this).addClass('active');

                    const filter = window.$(this).attr('data-filter');
                    const items = window.$('#work .single-work');

                    if (filter === '.all') {
                        items.fadeIn(300);
                    } else {
                        items.each(function () {
                            const $item = window.$(this);
                            if ($item.hasClass(filter.substring(1))) {
                                $item.fadeIn(300);
                            } else {
                                $item.fadeOut(300);
                            }
                        });
                    }
                });
            }
        }, 200);
    }

    loadArticles = async () => {
        try {
            this.setState({ loading: true, error: null });

            // Charger seulement les articles publics mis en avant sur l'accueil.
            const response = await publicApi.get('/api/articles?limit=9&featured=true');

            if (response.data.success && response.data.articles) {
                const articles = response.data.articles.filter(isPublicArticle);

                // Transformer les articles en format attendu par le composant
                const list = articles.map(article => {
                    const category = getCategoryFromType(article.type);

                    return {
                        id: article.id,
                        name: article.title,
                        value: article.excerpt || '',
                        route: `/article/${article.slug}`,
                        image: article.imageUrl || '',
                        categories: ['all', category]
                    };
                });

                this.setState({
                    list,
                    loading: false,
                    error: null
                });
            } else {
                this.setState({
                    list: [],
                    loading: false,
                    error: "Impossible de charger les articles mis en avant."
                });
            }
        } catch (error) {
            console.error("Error loading articles:", error);
            this.setState({
                list: [],
                loading: false,
                error: "Impossible de charger les articles mis en avant."
            });
        }
    }

    render() {
        let list = [];
        let i = 0;

        if (this.state.loading) {
            list = (
                <div className="col-12">
                    <Loading variant="dots" size="medium" color="primary" text="Chargement des travaux..." />
                </div>
            );
        } else if (this.state.error) {
            list = (
                <div className="col-12">
                    <div className="text-center py-5">
                        <p>{this.state.error}</p>
                        <button
                            type="button"
                            className="primary-btn mt-3"
                            data-text="Réessayer"
                            onClick={this.loadArticles}
                        >
                            {"Réessayer".split("").map((rows, keys) => <span key={keys}>{rows}</span>)}
                        </button>
                    </div>
                </div>
            );
        } else if (this.state.list.length === 0) {
            list = (
                <div className="col-12">
                    <div className="text-center py-5">
                        <p>Aucun article publié à la une pour le moment.</p>
                    </div>
                </div>
            );
        } else {
            for (let l of this.state.list) {
                // Animation CSS pure avec délai très court et synchronisé pour éviter les problèmes d'espacement
                // On utilise une classe d'animation personnalisée qui ne modifie pas le layout
                const animationDelay = (i * 0.1).toFixed(1); // Délai progressif mais très court (0.1s entre chaque)
                list.push(<div
                    key={l.id || i}
                    className={`single-work col-lg-4 col-md-6 col-sm-12 all ${l.categories.join(' ')} work-item-fade-in`}
                    style={{ animationDelay: `${animationDelay}s` }}
                >
                    <div className="relative">
                        <div className="thumb">
                            <div className="overlay overlay-bg"> </div>
                            <SafeImage className="image img-fluid" src={isEmpty(l.image) ? image_rand[Math.floor(Math.random() * image_rand.length)] : l.image} alt={l.name} />
                        </div>
                        <div className="middle">
                            <h4>{l.name}</h4>
                            {l.value && <div className="cat">{l.value}</div>}
                        </div>
                        <Link className="overlay" to={l.route}> </Link>
                    </div>
                </div>);

                i++;
            }
        }

        return (
            <>
                {/* Start Work Area Area */}
                <section className="work-area section-gap-top section-gap-bottom-90" id="work">
                    <div className="container">
                        <div className="row d-flex justify-content-between align-items-end mb-80">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    {/* « Articles » et non « Travaux » : les réalisations ont
                                        leur propre section (ProjectsShowcase) depuis l'ajout
                                        des pages projet. */}
                                    <h2>Mes Derniers Articles</h2>
                                    <p>{this.state.description}</p>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="filters">
                                    <ul>
                                        <li className="active" data-filter=".all">Toutes les catégories</li>
                                        <li data-filter=".stage">Stage</li>
                                        <li data-filter=".ppe">Projet Personnel Encadré</li>
                                        <li data-filter=".pp">Projet Personnel</li>
                                        <li data-filter=".veille">Veille</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="filters-content">
                            <div className="row">

                                {list}

                            </div>

                            {/* Bouton Voir plus d'articles */}
                            {!this.state.loading && this.state.list.length > 0 && (
                                <div className="row mt-5">
                                    <div className="col-12 text-center">
                                        <Link to="/article" className="primary-btn">
                                            <span className="lnr lnr-arrow-right"></span>
                                            Voir plus d'articles
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                {/* End Work Area Area */}
            </>
        );
    }
}
